import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  Stack,
  useToast,
} from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { deleteEvent, postDelete } from 'v4/store/actions/post.actions';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

const DeleteEventPopup = ({ isOpen, onClose, event, type, isDeleted }) => {
  const toast = useToast();
  const { t } = useTranslator();
  const dispatch = useDispatch();
  const router = useRouter();
  const {userProfileInfo} = useSelector(state => state.userProfile)

  const handleDeleteEvent = () => {
    let fn = null;
    if(event?.author?.id === userProfileInfo?.id) fn = postDelete;
    else fn = deleteEvent;
    
    dispatch(fn({ id: event?.id })).then((res) => {
      if(res?.payload?.response?.status_code >= 400){
        toast({
          title: res?.payload?.response?.detail || t('toast.genericError'),
          position: 'top',
          status: 'error',
          isClosable: true,
        });
      }
      else {
        toast({
          title: event?.event_type==='webinar' ? t('myEvents.webinarDeletedSuccessfully') || 'Webinar deleted successfully': t('myEvents.eventDeletedSuccessfully') || 'Event deleted successfully',
          position: 'top',
          status: 'success',
          isClosable: true,
        });
        isDeleted(true);
        router.push(`/myevents`);
      }
      onClose();
    });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent h={"200px"}>
        <Stack mt={2} mb={2}>
          <ModalHeader fontWeight={"medium"} fontSize={18} color={'#5B5B5B'}>
             {t('buttons.delete') || 'Delete'} {event?.event_type==='webinar' ? t('myEvents.webinar') || 'Webinar' : t('myEvents.generalEvent') || 'General Event'}
          </ModalHeader>
        </Stack>
        <ModalCloseButton />

        <ModalBody>
          <Stack mb={2}>
            <Text fontSize={14} color={'#5B5B5B'}>
              {event?.event_type==='webinar' ? t('myEvents.areYouSureDeleteWebinar')|| "Are you sure you want to delete this webinar" : t('myEvents.areYouSureDeleteEvent') || "Are you sure you want to delete this event"}
            </Text>
          </Stack>
        </ModalBody>
        <ModalFooter justifyContent="end">
          <Button
            borderRadius={"30px"}
            fontSize={16}
            color={'#4F4F4F'}
            variant="ghost"
            mr={3}
            onClick={onClose}
          >
            {t('buttons.cancel') || "Cancel"}
          </Button>
          <Button
            borderRadius={"30px"}
            fontSize={15}
            color={'white'}
            onClick={handleDeleteEvent}
            backgroundColor={'#E53E3E'}
            _hover={{
              backgroundColor: '#C53030'
            }}
          >
            {t('buttons.delete') || "Delete"}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteEventPopup;